import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { delay, filter, switchMapTo, take, timeout } from 'rxjs/operators';
import { AppLoaderService } from './app-loader.service';

/**
 * AppLoaderFactory - need to run this as part of the Angular App Initializer in order to
 *                    hook into Navigation events before the directive is initialized.
 * @param service
 * @param router
 */
export const AppLoaderFactory =
  (service: AppLoaderService, router: Router) => () => {
    router.events
      .pipe(
        filter((evt) => {
          return (
            evt instanceof ActivationEnd &&
            evt.snapshot.data?.ignoreLoader !== true
          );
        }),
        take(1),
        switchMapTo(
          router.events.pipe(filter((evt) => evt instanceof NavigationEnd))
        ),
        delay(500), // Short delay just in case
        timeout(10000) // Add a timeout if something goes wrong to hide loader
      )
      .subscribe({
        next: () => service.removeLoader(),
        error: () => service.removeLoader(),
      });
  };
